import { renderLabelWithDescriptionLayoutTemplate } from '@next-adapter/templates/renderers/generators/form/form-shared/label-with-description.js'
export function labelWithDescription(
  labelJSX: string,
  descriptionJSX: string,
  indent: string
): string {
  if (!descriptionJSX) return labelJSX
  return renderLabelWithDescriptionLayoutTemplate({
    indent: indent,
    labelJsx: labelJSX,
    descriptionJsx: descriptionJSX
  })
}
